import { AxiosResponse, AxiosError } from 'axios';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ACTION_FETCH } from './const';
import {
  Items,
  Params,
  FetchParams,
  Providers,
  State,
  Statuses,
} from './types';
import { Dictionary } from '@/types';

const { ERROR, READY, WAITING } = Statuses;

const CHECK_PARAMS = 'checkParams';
const FETCH_ITEMS = 'fetchItems';
const SET_ITEMS = 'setItems';
const SET_PARAMS = 'setParams';
const SET_STATUS = 'setStatus';

const storeModule = ({ $api, $config }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class PageOrganizationStore extends VuexModule<State, any> {
    // State
    items: Items = [];
    section: string = '';
    status: Statuses = READY;
    subSection: string = '';
    year: number | null = null;
    month: number | null = null;

    // Mutations
    @Mutation
    [SET_ITEMS](items: Array<any>) {
      this.items = items.map(({ date, count }) => ({
        count: typeof count === 'string' ? parseInt(count, 10) : count,
        date: new Date(date),
      }));
    }

    @Mutation
    [SET_PARAMS]({ year, month, section, subSection }: FetchParams) {
      this.month = month;
      this.section = section;
      this.subSection = subSection;
      this.year = year;
    }

    @Mutation
    [SET_STATUS](status: Statuses) {
      this.status = status;
    }

    // Actions
    @Action
    async [CHECK_PARAMS](params: Params) {
      const { commit } = this.context;
      try {
        const year = parseInt(params.year, 10);
        const month = parseInt(params.month, 10);
        const { section, subSection } = params;
        commit(SET_PARAMS, { month, year, section, subSection });
      } catch (e) {
        commit(SET_STATUS, ERROR);
      }
    }

    @Action
    async [ACTION_FETCH](params: Params) {
      const { status } = this;
      // if (status === WAITING) return;

      const { commit, dispatch } = this.context;
      const { section, subSection } = params;

      try {
        commit(SET_STATUS, WAITING);
        const year = parseInt(params.year, 10);
        const month = parseInt(params.month, 10);
        await dispatch(FETCH_ITEMS, { ...params, year, month });
        commit(SET_PARAMS, { month, section, subSection, year });
        commit(SET_STATUS, READY);
      } catch (e) {
        commit(SET_STATUS, ERROR);
      }
    }

    @Action
    async [FETCH_ITEMS](p: FetchParams) {
      const { commit } = this.context;
      const params: Dictionary<any> = { ...p };
      params.subsection = params.subSection;
      delete params.subSection;
      delete params.date;
      delete params.month;
      delete params.year;
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (value === null || value === '') delete params[key];
      });
      if (params.members != null && !Array.isArray(params.members)) {
        params.members = [params.members];
      }
      try {
        const { data } = await $api.get<AxiosResponse<Items>>(
          `activity/schedule/${p.year}/${p.month}/get`,
          { params },
        );
        commit(SET_ITEMS, data.data);
      } catch (e) {
        // Обрабатываем ошибку
        commit(SET_STATUS, ERROR);
      }
    }
  }

  return PageOrganizationStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/activities/calendar/store.ts